const formatYearsInText = (years: Array<number>) => {
  if (years.length === 0) {
    return ''
  } else if (years.length === 1) {
    return years[0].toString()
  } else if (years.length === 2) {
    return years.join(' e ')
  } else {
    let lastYear = years.pop()
    return `${years.join(', ')} e ${lastYear}`
  }
}

export default formatYearsInText
